import { Controller } from "stimulus"

const rolesWithUnlimitedClients = [ "holiness", "admin", "qa" ]
const roleClientsLimit = role => (rolesWithUnlimitedClients.indexOf(role) === -1 ? 1 : 0)

export default class extends Controller {
  static targets = [ "clientsCheckBoxes" ]

  roleChanged({ target }) {
    this.updateClientsLimit(target.checked ? target.value : null)
  }

  updateClientsLimit(role) {
    if (!this.hasClientsCheckBoxesTarget) return

    const limit = roleClientsLimit(role)
    this.clientsCheckBoxesTarget.setAttribute("data-check-box-group-limit-value", limit)
  }
}
